export const pages = {
    'login.lead.default': 'Access for members of an organisation.',
    'login.lead.bootstrap': 'No account exists yet. The first one also creates the organisation and administers it.',
    'login.lead.forgot': 'Enter your address — we will send you a link for setting a new password.',
    'login.orgPlaceholder': 'Company name',
    'login.namePlaceholder': 'First and last name',
    'login.signIn': 'Sign in',
    'login.createAccount': 'Create account',
    'login.requestLink': 'Request link',
    'login.forgot': 'Forgot your password?',
    'login.backToSignIn': 'Back to sign-in',
    'login.whatIsPraesto': 'What is Præsto?',
    'login.failed': 'Sign-in failed.',
    'login.sent': 'If an account exists for {email}, an email with a link for setting a new password is on its way. The link is valid for two hours.',
    'boards.title': 'Boards',
    'boards.lead': 'Whiteboards from {org} — for concepts, moodboards and client presentations.',
    'boards.leadPlain': 'Whiteboards for concepts, moodboards and client presentations.',
    'boards.new': 'New board',
    'boards.loadFailed': 'Boards could not be loaded.',
    'boards.copyFailed': 'The board could not be copied.',
    'boards.switchOrg': 'Switch organisation',
    'boards.design': 'Design',
    'boards.designTitle': 'Default design and fonts of this organisation',
    'boards.customers': 'Customers',
    'boards.customersTitle': 'All customers, plans and terms',
    'boards.manual': 'Manual',
    'boards.manualTitle': 'Guide to Præsto',
    'boards.accountTitle': 'Your own account and password',
    'boards.signOut': 'Sign out',
    'boards.storageUsed': 'used in this organisation',
    'boards.storageHidden': ' · {size} of it in boards not shared with you',
    'boards.emptyTitle': 'No board yet',
    'boards.emptyLead': 'Create your first board, drag images onto it and zoom your way through the presentation.',
    'boards.wholeOrg': 'Whole organisation',
    'boards.private': 'Private',
    'boards.privateWith': 'Private · {people}',
    'boards.sizeTitle': 'Storage used by all media on this board, including the generated resolution levels',
    'boards.duplicateLabel': 'Duplicate {title}',
    'boards.duplicateTitle': 'Copy board — with content, files and speaker notes',
    'manual.path': '/handbuch/en',
    'start.path': '/en/',
    'board.notFound': 'This board does not exist, or you do not have access to it.',
    'board.loadFailed': 'The board could not be loaded.',
    'board.loading': 'Loading board …',
    'board.toOverview': 'To the overview',
    'board.guest': 'Guest',
    'board.frameName': 'Frame {number}',
    'board.connection': 'Connection: {status}',
    'board.historyTitle': 'History — view and restore earlier states of this board',
    'board.themeTitle': 'Board design — colours and fonts',
    'board.share': 'Share',
    'board.present': 'Present',
    'board.viewOnly': 'View only',
    'board.frameBack': 'Previous frame',
    'board.frameForward': 'Next frame',
    'board.frameOf': 'Frame {index} of {total}',
    'board.smallScreen': 'Viewing only on this screen.',
    'board.smallScreenAnyway': 'Edit anyway',
    'board.insert.media': 'Media',
    'board.insert.website': 'Website',
    'board.insert.text': 'Text',
    'board.insert.frame': 'Frame',
    'board.insert.frameTitle': 'Create a frame — pick a format, draw freely or wrap the selection',
    'frame.format.wide': 'Widescreen',
    'frame.format.classic': 'Classic',
    'frame.format.square': 'Square',
    'frame.format.post': 'Post',
    'frame.format.story': 'Story',
    'frame.menu.formats': 'Format',
    'frame.menu.draw': 'Draw freely',
    'frame.menu.drawHint': 'Drag a frame on the board',
    'frame.menu.around': 'Around selection',
    'frame.menu.aroundHint': 'Wraps a frame around the selected objects',
    'frame.menu.aroundEmpty': 'Select something first',
    'frame.draw.hint': 'Drag to define the frame — Esc cancels',
    'board.insert.template': 'Frame template',
    'board.insert.templateTitle': 'Insert a saved frame including its content',
    'board.insert.boardTemplate': 'Board template',
    'board.insert.boardTemplateTitle': 'Create a skeleton of empty frames',
    'board.panHint': 'Drag to pan · ⌘/Ctrl + scroll to zoom',
    'board.uploading.one': 'Processing file …',
    'board.uploading.many': 'Processing {count} files …',
    'board.uploadFailed': '“{name}” could not be uploaded.',
    'demo.preparing': 'Preparing the demo …',
    'demo.preparingTalk': 'Preparing the talk …',
    'demo.failed': 'The demo cannot be opened right now. Please try again later.',
    'showcase.preparing': 'Preparing the showing …',
    'showcase.failed': 'The showing cannot be opened right now. Please try again later.',
    'showcase.bar.text': 'A showing — you are watching as a guest.',
    'showcase.bar.try': 'Try it yourself',
    'showcase.bar.about': 'What is Præsto?',
    'guest.hint.explore': 'You can look around the board freely. Nothing can be changed.',
    'guest.hint.guided': 'The view follows the presenter. You can break away and return at any time.',
    'guest.hint.locked': 'You see exactly what the presenter is showing, throughout.',
    'guest.linkFailed': 'The link could not be opened.',
    'guest.nameRequired': 'Please enter your name.',
    'guest.joinFailed': 'Joining failed.',
    'guest.opening': 'Opening board …',
    'guest.yourName': 'Your name',
    'guest.namePlaceholder': 'How should the others see you?',
    'guest.enter': 'Enter board',
    'redeem.checkFailed': 'This link could not be checked.',
    'redeem.mismatch': 'The two passwords do not match.',
    'redeem.expiredHint': 'Links are valid for a limited time and only once. Request a new one via “Forgot your password?” or ask to be invited again.',
    'redeem.toSignIn': 'To sign-in',
    'redeem.invited': 'You have been invited to {org}. Set a password and you are ready to go.',
    'redeem.reset': 'Set a new password for {email}.',
    'redeem.yourName': 'Your name',
    'redeem.nameHint': 'This is how the others see you on the board.',
    'redeem.start': 'Get started',
    'redeem.setPassword': 'Set password',
    'signup.lead': 'Try it for 14 days, no payment details. After that we will get in touch — nobody loses anything immediately by not renewing.',
    'signup.orgPlaceholder': 'Name of your agency',
    'signup.plan': 'Plan',
    'signup.perMonth': '€{price}/month',
    'signup.planSummary': '{members} people, {storage}.',
    'signup.switchAnytime': 'You can switch at any time.',
    'signup.submit': 'Try for free',
    'signup.haveAccount': 'I already have an account',
    'signup.yourOrg': 'your organisation',
    'signup.sent': 'We have sent an email to {email}. It contains a link for setting your password — after that {org} is ready.',
    'signup.spamHint': 'Nothing arrived? Check your spam folder. The link is valid for two weeks.',
    'signup.backToOverview': 'Back to the overview',
    'common.failed': 'That did not work.',
};
//# sourceMappingURL=pages.js.map